module.exports = __webpack_public_path__ + "img/film.6cbe190e.png";